import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
import { Photos } from '@spa/shared/components/Search/Card/Gallery/styles';
import { Wrapper as MoreListingsWrapper } from '@spa/offer/components/MoreListings/styles';
import { Title as OfferCardTitle, WrapperLink } from '@spa/shared/components/Search/Card/OfferCard/styles';
import { Wrapper as CarouselOverallWrapper, Header, Carousel } from '@spa/shared/components/SimpleCarousel/styles';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1epx5fl-0"
})(["width:100%;max-width:100%;margin-top:", ";", " ", "{", ";margin-top:0;color:", ";", "{", ";", "{p{font-size:", ";line-height:", ";font-weight:600;}}", "{", ";}}", " & > div{", ";}", "{min-width:291px;", "{height:240px;}", "{display:inline;}}}"], function (props) {
  return props.theme.space(2);
}, mediaMin.smallBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: ", ";\n  "])), function (props) {
  return props.theme.space(1);
}), MoreListingsWrapper, function (props) {
  return props.theme.gap(10);
}, function (props) {
  return props.theme.morePlacesLikeThisSection.textColor;
}, CarouselOverallWrapper, function (props) {
  return props.theme.gap(10);
}, Header, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, Carousel, function (props) {
  return props.theme.gap(3);
}, mediaMin.smallBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n    "])), function (_ref) {
  var theme = _ref.theme;
  return theme.gap(7);
}), function (props) {
  return props.theme.gap(3);
}, WrapperLink, Photos, OfferCardTitle);